import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { BuilderExtension } from "./BuilderExtension";
import { ValueExtension } from "./adapters/ValueExtension";
export var ChainBuilder = /*#__PURE__*/function (_BuilderExtension) {
  _inherits(ChainBuilder, _BuilderExtension);
  var _super = _createSuper(ChainBuilder);
  function ChainBuilder(lastExtension) {
    var _this;
    _classCallCheck(this, ChainBuilder);
    _this = _super.call(this);
    _this.lastExtension = lastExtension;
    return _this;
  }
  _createClass(ChainBuilder, [{
    key: "create",
    value: function create(data, params) {
      return this.lastExtension.create(data, params);
    }
  }, {
    key: "createProjection",
    value: function createProjection(data, params) {
      return this.lastExtension.createProjection(data, params);
    }
  }, {
    key: "serialize",
    value: function serialize(cls) {
      return this.lastExtension.serialize(cls);
    }
  }, {
    key: "with",
    value: function _with(extension) {
      extension.setNext(this.lastExtension);
      this.lastExtension = extension;
      return this;
    }
    //
    // serializeProjection(cls: C, ctx: ExecutionContext): D {
    //   return this.lastExtension.serializeProjection(cls, ctx);
    // }
  }], [{
    key: "from",
    value: function from(ClassOrBuilder) {
      if (ClassOrBuilder instanceof BuilderExtension) {
        return new ChainBuilder(ClassOrBuilder);
      }
      return new ChainBuilder(new ValueExtension(ClassOrBuilder));
    }
  }]);
  return ChainBuilder;
}(BuilderExtension);